<template>
  <v-container fluid class="px-1 py-1">
    <CommonTable
        :title=title
        :embedded="embedded"
        :height="height"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreMaterial/MaterialLocation/MaterialLocationDetail"
        :parent-component="$options.name"
        :main-validator="true"
        @embedded_action="onEmbeddedAction($event)"
    >
      <template v-slot:item.parent_uid="{ item }">
        <span v-if="!!item.parent_uid && storeAggregate.rootData">
          {{storeAggregate.rootData[item.parent_uid].name}}
        </span>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import MaterialLocationDetail from "@/components/CoreMaterial/MaterialLocation/MaterialLocationDetail";
import BaseFieldCheck from "@/components/Base/BaseFieldCheck";
import {v4 as uuidv4} from "uuid";
import {useDetailStore} from "@/components/Common/CommonDetail";

export default {
  name: "MaterialLocationTable",

  props: {
    title: {default: 'MaterialLocation'},
    embedded: {default: false},
    height: {default: null},
    parentUid: {default: null},
    storeName: {type: [String], default: 'MaterialLocationTable'},
    dtoDetailQuery: {default: 'MaterialLocationDetailQueryDTO'},
    detailStoreName: {
      type: [String], default() {
        return uuidv4()
      }
    },
    dtoValidateCommand: {type: [String], default: 'MaterialLocationValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'MaterialLocationListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialLocationActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    MaterialLocationDetail,
    BaseFieldCheck,
  },

  methods: {
    onEmbeddedAction(event) {
      // console.log('onEmbeddedAction', event)
      if (event.actionName === 'embedded_new') {
        // console.log('embedded_new_article', event, this.parentUid)
        this.storeDetail.uidItem = uuidv4()
        this.storeDetail.parentUid = this.parentUid
        this.storeDetail.dialogDetail = true
      }
    },
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.storeDetail = useDetailStore(this.detailStoreName)()
    this.storeTable.headers = [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Parent', value: 'parent_uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Fullname', value: 'fullname', sortable: false, filterable: true, divider: true, width: 600},
      {text: 'Description', value: 'description', sortable: true, filterable: true, divider: true},
      {text: 'T °C', value: 'temperature', sortable: true, filterable: true, divider: true},
      {text: 'QR', value: 'qrcode', sortable: true, filterable: true, divider: true, width: 30, type: 'qrcode'},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
    this.storeAggregate = useAggregateStore()
    if (!!this.storeTable) {
      this.storeTable.dtoDetailQuery = this.dtoDetailQuery
      this.storeTable.dtoListQuery = this.dtoListQuery
      this.storeTable.dtoActionCommand = this.dtoActionCommand
      this.storeTable.options.sortBy = ['name']
    }
  },

  data() {
    return {
      storeTable: null,
    }
  },
}
</script>

<style scoped>

</style>